if (typeof google !== 'undefined' && window.jQuery) {
	window.addEventListener('load', initMap);
	window.addEventListener('DOMContentLoaded', initMap);
}

const storeDetailsBtnAction = (target) => {
	const storesWrapper = document.querySelector(".store-list");
	storesWrapper.classList.remove('detail-view-active');
	document.querySelector('.active-store') && document.querySelector('.active-store').classList.remove('active-store');

	var id = $(target).data("id");
	var activeStoreWrapper = $('#store-' + id);
	storesWrapper.classList.add('detail-view-active');
	activeStoreWrapper.addClass('active-store');
	document.querySelector('#mobile-view-toggle').click();
};

const initStoreDetailsMapBtn = () => {
	const storeDetailsBtn = $('.map-container .store-details-btn');
	if (storeDetailsBtn.length) {
		storeDetailsBtn.on("click", function(event) {
			storeDetailsBtnAction(event.currentTarget);
		});
	} else {
		const intervalId = setInterval(() => {
			const storeDetailsBtnCheck = $('.map-container .store-details-btn');
			if (storeDetailsBtnCheck.length) {
				storeDetailsBtnCheck.on("click", function(event) {
					storeDetailsBtnAction(event.currentTarget);
				});
				clearInterval(intervalId);
			}
		}, 100);
	}
};
function initMap() {
	// Basic options for a simple Google Map
	// For more options see: https://developers.google.com/maps/documentation/javascript/reference#MapOptions
	// Get the HTML DOM element that will contain your map
	// We are using a div with id="map" seen below in the <body>
	let mapElement = document.getElementById("map");

	if (mapElement) {
		// get starting lat lon
		const lat = parseFloat($('#startingLatitude').val());
		const lon = parseFloat($('#startingLongitude').val());

		var mapOptions = {
			// How zoomed in you want the map to start at (always required)
			zoom: 7,
			// The latitude and longitude to center the map (always required)
			center: new google.maps.LatLng(lat, lon),
			// How you would like to style the map.
			// This is where you would paste any style found on Snazzy Maps.
			styles: [
				{
					featureType: "water",
					elementType: "geometry",
					stylers: [
						{
							color: getComputedStyle(document.documentElement).getPropertyValue('--gmaps-water').trim() || '#e9e9e9',
						},
						{
							lightness: 15,
						},
					],
				},
				{
					featureType: "landscape",
					elementType: "geometry",
					stylers: [
						{
							color: getComputedStyle(document.documentElement).getPropertyValue('--gmaps-landscape').trim() || "#f5f5f5",
						},
						{
							lightness: 15,
						},
					],
				},
				{
					featureType: "road.highway",
					elementType: "geometry.fill",
					stylers: [
						{
							color: "#ffffff",
						},
						{
							lightness: 17,
						},
					],
				},
				{
					featureType: "road.highway",
					elementType: "geometry.stroke",
					stylers: [
						{
							color: "#ffffff",
						},
						{
							lightness: 29,
						},
						{
							weight: 0.2,
						},
					],
				},
				{
					featureType: "road.arterial",
					elementType: "geometry",
					stylers: [
						{
							color: "#ffffff",
						},
						{
							lightness: 18,
						},
					],
				},
				{
					featureType: "road.local",
					elementType: "geometry",
					stylers: [
						{
							color: "#ffffff",
						},
						{
							lightness: 16,
						},
					],
				},
				{
					featureType: "poi",
					elementType: "geometry",
					stylers: [
						{
							color: "#f5f5f5",
						},
						{
							lightness: 21,
						},
					],
				},
				{
					featureType: "poi.park",
					elementType: "geometry",
					stylers: [
						{
							color: getComputedStyle(document.documentElement).getPropertyValue('--gmaps-park').trim() || "#dedede",
						},
					],
				},
				{
					elementType: "labels.text.stroke",
					stylers: [
						{
							visibility: "on",
						},
						{
							color: "#ffffff",
						},
						{
							lightness: 16,
						},
					],
				},
				{
					elementType: "labels.text.fill",
					stylers: [
						{
							saturation: 36,
						},
						{
							color: "#333333",
						},
						{
							lightness: 40,
						},
					],
				},
				{
					elementType: "labels.icon",
					stylers: [
						{
							visibility: "off",
						},
					],
				},
				{
					featureType: "transit",
					elementType: "geometry",
					stylers: [
						{
							color: "#f2f2f2",
						},
						{
							lightness: 19,
						},
					],
				},
				{
					featureType: "administrative",
					elementType: "geometry.fill",
					stylers: [
						{
							color: "#fefefe",
						},
						{
							lightness: 20,
						},
					],
				},
				{
					featureType: "administrative",
					elementType: "geometry.stroke",
					stylers: [
						{
							color: "#fefefe",
						},
						{
							lightness: 17,
						},
						{
							weight: 1.2,
						},
					],
				},
			],
		};
		// Create the Google Map using our element and options defined above
		let map = new google.maps.Map(mapElement, mapOptions);
		let locations = [];
		let allStoreDiv = document.querySelectorAll('#store>div:not(.query-hidden):not(.filter-hidden)');

		for (var i = 0; i < allStoreDiv.length; i++) {
			let location = {};
			location.name = allStoreDiv[i].querySelector('.store-name') && allStoreDiv[i].querySelector('.store-name').innerHTML;
			location.distance = allStoreDiv[i].querySelector('.store-distance-info') && allStoreDiv[i].querySelector('.store-distance-info').innerHTML;
			location.openTime = allStoreDiv[i].querySelector('.open-time') && allStoreDiv[i].querySelector('.open-time').outerHTML;
			location.latitude = allStoreDiv[i].getAttribute('data-latitude');
			location.longitude = allStoreDiv[i].getAttribute('data-longitude');
			location.detailsButton = allStoreDiv[i].querySelector('.store-details-btn') && allStoreDiv[i].querySelector('.store-details-btn').outerHTML;

			locations.push(location);
		}

		let markers = [];
		let markerImage = getComputedStyle(document.querySelector('.map-marker')).backgroundImage.match(/url\(["']?([^"']*)["']?\)/)[1];
		let selectedMarkerImage = getComputedStyle(document.querySelector('.map-marker-selected')).backgroundImage.match(/url\(["']?([^"']*)["']?\)/)[1];

		const infowindow = new google.maps.InfoWindow({});

		function createMarker(position, location, map) {
			var marker = new google.maps.Marker({
				map: map,
				position: position,
				icon: markerImage,
			});
			marker.addListener('click', function() {
				changeIcon(this);

				let html = `
                    <div class="info-window-content">
                        <h2 class="info-window-title">${ location.name }</h2>
                        <p class="info-window-description">${ location.distance }</p>
                        ${ location.openTime }
                        ${ location.detailsButton }
                    </div>
                `;
				highlightStore(location.name);
				infowindow.close();
				setTimeout(() => {
					infowindow.setContent(html);
					infowindow.open(map, marker);
					google.maps.event.trigger(map, 'resize');
				}, 200);
				map.panTo(this.getPosition());
				initStoreDetailsMapBtn();
				document.querySelector("html").scroll({ top: 0, behavior: 'smooth' });
			});

			markers.push(marker);
			return marker;
		}

		function changeIcon(icon) {
			restoreIcons();
			icon.setIcon(selectedMarkerImage);
		}

		function restoreIcons() {
			for (var i = 0; i < markers.length; i++) {
				markers[i].setIcon(markerImage);
			}
		}

		function highlightStore(storeName) {
			document.querySelector('.highlighted-store') && document.querySelector('.highlighted-store').classList.remove('highlighted-store');
			document.querySelector('.active-store') && document.querySelector('.active-store').classList.remove('active-store');
			document.querySelector(`[data-store-name="${ storeName }"]`).classList.add('highlighted-store');
			document.querySelector(`[data-store-name="${ storeName }"]`).classList.add('active-store');
		}

		function initMarkers() {
			for (i = 0; i < locations.length; i++) {
				if(locations[i].latitude && locations[i].longitude){
					createMarker(new google.maps.LatLng(locations[i].latitude, locations[i].longitude), locations[i], map, location);
				}
			}

			var bounds = new google.maps.LatLngBounds();
			for (var i = 0; i < markers.length; i++) {
				bounds.extend(markers[i].position);
			}
			map.fitBounds(bounds);
		}
		initMarkers();
	}
}

function removeStoreNameFromUrl() {
	const originalUrl = window.location.pathname;
	history.replaceState({}, '', originalUrl);
}

const StoreSearch = (function StoreSearch() {
	let allStoreDiv = document.querySelectorAll('#store>div');
	let filteredStores = document.querySelectorAll('#store > .sr-list:not(.hidden)');
	let departmentIds = [];
	let amenityIds = [];
	let selectedValue = 0;
	let latitude = parseFloat($('#startingLatitude').val());
	let longitude = parseFloat($('#startingLongitude').val());
	let searchTypingTimer;
	let finishedTypingInterval = 500;
	let searchQuery = "";
	const viewAllBtns = document.querySelectorAll('.view-all-services');
	const storeDetailsBtns = document.querySelectorAll('.store-details-btn');
	const storesWrapper = document.querySelector(".store-list");


	function attachEvents() {
		// OPEN FILTERS
		$("#fl-btn").click(function() {
			showFilters();
		});
		// CLOSE FILTERS 
		$("#close-btn").click(function() {
			hideFilters();
		});
		// SHOW RESULTS
		$('#showresult').on('click', function() {
			renderFilteredResults();
			hideFilters();
		});
		// CLEAR FITLERS
		$("#clearFilters").on("click", function() {
			var allDivData = document.querySelectorAll(".filter-box .js-search-trigger");
			departmentIds = [];
			amenityIds = [];
			selectedValue = 0;

			for (var i = 0; i < allDivData.length; i++) {
				allDivData[i].classList.remove("active");
			}

			document.querySelectorAll('.store-active-filters').forEach(storeFilters => {
				storeFilters.innerHTML = '';
				storeFilters.classList.remove('show');
			});
			document.querySelectorAll('.filter-count-detail').forEach(element => {
				element.innerHTML = "(" + selectedValue + ")";
			});

			renderFilteredResults();
		});
		// ADD FILTER
		$('.filter-main .js-search-trigger').on('click', function() {
			departmentIds = [];
			amenityIds = [];

			$(this).toggleClass('active');

			for (var i = 0; i < document.querySelectorAll(".depart-cl .js-search-trigger").length; i++) {
				if (document.querySelectorAll(".depart-cl .js-search-trigger")[i].classList.contains('active')) {
					departmentIds.push(document.querySelectorAll(".depart-cl .js-search-trigger")[i].getAttribute('data-id'));
				}
			}

			for (var i = 0; i < document.querySelectorAll(".amenities-cl .js-search-trigger").length; i++) {
				if (document.querySelectorAll(".amenities-cl .js-search-trigger")[i].classList.contains('active')) {
					amenityIds.push(document.querySelectorAll(".amenities-cl .js-search-trigger")[i].getAttribute('data-id'));
				}
			}
			if (this.classList.contains("active")) {
				selectedValue++;
			} else {
				selectedValue--;
			}
			document.querySelectorAll('.filter-count-detail').forEach(element => {
				element.innerHTML = "(" + selectedValue + ")";
			});
		});
		// UPDATE LOCATION
		$('#spnLocation').on('click', function() {
			getLocation();
		});
		// INPUT CHANGE
		document.querySelector('#storeSearchInput') && document.querySelector('#storeSearchInput').addEventListener('input', function(e) {
			searchQuery = e.target.value;
			clearTimeout(searchTypingTimer);
			searchTypingTimer = setTimeout(renderQueryResults, finishedTypingInterval);
		});
		// MOBILE MAP TOGGLE
		$("#mobile-view-toggle").on("click", function() {
			if ($(this).hasClass('mobile-map-view')) {
				$("#map").addClass("show");
				document.querySelector('.store-location-banner').classList.add('d-none');
				$("body").addClass("overflow-hidden");
				$(this).removeClass("mobile-map-view").addClass("mobile-list-view");
			} else {
				$("#map").removeClass("show");
				document.querySelector('.store-location-banner').classList.remove('d-none');
				$("body").removeClass("overflow-hidden");
				$(this).removeClass("mobile-list-view").addClass("mobile-map-view");
			}
		});
		// VIEW ALL BUTTONS
		$('.view-all-services').on("click", function() {
			var id = $(this).data("id");
			var text = $(this).text();
			var servicesList = $('#services-' + id);
			if (text == 'View All') {
				servicesList.toggleClass('open');
				$(this).text('View Less');
				servicesList.children(".service-icon").toggleClass("service-icon service-icon-no-show");
			} else {
				servicesList.toggleClass('open');
				servicesList.children(".service-icon-no-show").toggleClass("service-icon-no-show service-icon");
				$(this).text('View All');
			}
		});
		// STORE DETAIL BUTTONS
		$('.store-details-btn').on("click", function() {
			var id = $(this).data("id");
			var storeName = $(this).closest('[data-store-name]').data('store-name');
			var activeStoreWrapper = $('#store-' + id);
			storesWrapper.classList.add('detail-view-active');
			activeStoreWrapper.addClass('active-store');
			const newUrl = `${window.location.pathname}?store-name=${encodeURIComponent(storeName)}`;
			history.pushState({ storeName }, '', newUrl);
		});
		$('#btnStoreDetailsBack').on('click', function(e) {
			e.preventDefault();
			storesWrapper.classList.remove('detail-view-active');
			removeStoreNameFromUrl();
			// document.querySelector('.store-location-banner').classList.remove('d-none');
			document.querySelector('.active-store') && document.querySelector('.active-store').classList.remove('active-store');
		});
	}

	window.addEventListener('popstate', (event) => {
		storesWrapper.classList.remove('detail-view-active');
		removeStoreNameFromUrl();
		// document.querySelector('.store-location-banner').classList.remove('d-none');
		document.querySelector('.active-store') && document.querySelector('.active-store').classList.remove('active-store');
	});

	function showFilters() {
		$("#fl-list").removeClass("inactive");
		$("#fl-list").addClass("active");
		$(".scroll-wrapper").removeClass("active");
		$(".scroll-wrapper").addClass("inactive");
	}

	function hideFilters() {
		$("#fl-list").addClass("inactive");
		$("#fl-list").removeClass("active");
		$(".scroll-wrapper").addClass("active");
		$(".scroll-wrapper").removeClass("inactive");
	}

	function renderQueryResults() {
		// show all stores by default
		document.querySelector('.no-stores-found').style.display = "none";
		let storeDiv = document.querySelectorAll('#store > .sr-list');

		setDistances(latitude, longitude);
		sortStoresByDistance();

		for (var i = 0; i < storeDiv.length; i++) {
			storeDiv[i].classList.remove('query-hidden');
		}

		if (searchQuery) {
			function is_usZipCode(str) {
				regexp = /^[0-9]{5}(?:-[0-9]{4})?$/;
				if (regexp.test(str)) {
					return true;
				} else {
					return false;
				}
			}

			var query = { address: searchQuery, region: "US" };
			if (is_usZipCode(searchQuery)) {
				query = {
					componentRestrictions: {
						country: 'US',
						postalCode: searchQuery
					}
				};
			} else {
				query = {
					componentRestrictions: {
						country: 'US',
						administrativeArea: searchQuery //if search isn't in zip code format, set the country to the U.S and search using administrativeArea.
					}
				};
			}

			const geocoder = new google.maps.Geocoder();
			geocoder.geocode(query, (results, status) => {
				if (status === "OK") {
					if (results[0]) {
						setDistances(results[0].geometry.location.lat(), results[0].geometry.location.lng());
						sortStoresByDistance();
						// document.querySelector(".store-list").scroll({ top: 0, behavior: 'smooth' });
						document.querySelector("html").scroll({ top: 0, behavior: 'smooth' });
						let storeDiv = document.querySelectorAll('#store > .sr-list');
						for (var i = 0; i < storeDiv.length; i++) {
							let storeDistance = storeDiv[i].querySelector('.store-distance-info').innerHTML.split(' ')[0];
							if (Number(storeDistance) > 50) {
								storeDiv[i].classList.add('query-hidden');
							}
						}
						checkStoresLength();
					} else {
						document.querySelector('.no-stores-found').style.display = "block";
						let storeDiv = document.querySelectorAll('#store > .sr-list');
						for (var i = 0; i < storeDiv.length; i++) {
							storeDiv[i].classList.add('query-hidden');
						}
					}
				} else {
					document.querySelector('.no-stores-found').style.display = "block";
					let storeDiv = document.querySelectorAll('#store > .sr-list');
					for (var i = 0; i < storeDiv.length; i++) {
						storeDiv[i].classList.add('query-hidden');
					}
					console.debug("Geocoder failed due to: " + status);
				}
			});
		}

		checkStoresLength();
		initMap();
	}

	function renderFilteredResults() {
		let storeDiv = document.querySelectorAll('#store > .sr-list');
		let sortByNearestEl = document.querySelector('.sort-box #nearest');
		let sortByRelevancy = document.querySelector('.sort-box #relevant');

		for (var i = 0; i < storeDiv.length; i++) {
			storeDiv[i].classList.remove('filter-hidden');
		}

		if (departmentIds.length > 0 || amenityIds.length > 0) {
			for (var i = 0; i < storeDiv.length; i++) {
				let currentStoreAmenities = [];
				let currentStoreDepartments = [];

				if (storeDiv[i].getAttribute('data-amenities')) {
					currentStoreAmenities = storeDiv[i].getAttribute('data-amenities').split(',');
				}
				if (storeDiv[i].getAttribute('data-departments')) {
					currentStoreDepartments = storeDiv[i].getAttribute('data-departments').split(',');
				}
				const filteredAmenities = amenityIds.filter(value => currentStoreAmenities.includes(value));
				const filteredDepartment = departmentIds.filter(value => currentStoreDepartments.includes(value));
				let html = '';

				if (amenityIds.length > 0) {
					html = `
                            ${ amenityIds.map(el => {
						return currentStoreAmenities.includes(el.toString())
							? `<div class="active-filter active">
                                                <span class="icon-circle-check"></span>
                                                <span>${ el }</span>
                                            </div>`
							: `<div class="active-filter inactive">
                                                <span class="icon-circle-x"></span>
                                                <span>${ el }</span>
                                            </div>`;
					}).join('') }`;
				}

				if (departmentIds.length > 0) {
					html += `
                            ${ departmentIds.map(el => {
						return currentStoreDepartments.includes(el.toString())
							? `<div class="active-filter active">
                                                <span class="icon-circle-check"></span>
                                                <span>${ el }</span>
                                            </div>`
							: `<div class="active-filter inactive">
                                                <span class="icon-circle-x"></span>
                                                <span>${ el }</span>
                                            </div>`;
					}).join('') }`;
				}

				storeDiv[i].querySelector('.store-active-filters').innerHTML = html;
				storeDiv[i].querySelector('.store-active-filters').classList.add('show');

				if (filteredAmenities.length == 0 && filteredDepartment.length == 0) {
					storeDiv[i].classList.add('filter-hidden');
					storeDiv[i].querySelector('.store-active-filters').classList.remove('show');
				}
			}
		}

		if (sortByRelevancy.checked) {
			sortStoresByRelevancy();
		}

		if (sortByNearestEl.checked) {
			sortStoresByDistance();
		}

		checkStoresLength();
		initMap();
	}

	function getLocation() {
		if (navigator.geolocation) {
			navigator.geolocation.getCurrentPosition(showPosition);
			document.querySelector('#storeSearchInput').value = "";
		} else {
			x.innerHTML = "Geolocation is not supported by this browser.";
		}
	}

	function checkStoresLength() {
		let renderedStores = document.querySelectorAll('#store > .sr-list:not(.query-hidden):not(.filter-hidden)');
		renderedStores.length === 0
			? document.querySelector('.no-stores-found').style.display = "block"
			: document.querySelector('.no-stores-found').style.display = "none";
	}

	function setDistances(latitude, longitude) {
		for (var i = 0; i < allStoreDiv.length; i++) {
			var store = allStoreDiv[i];
			var storeLatitude = store.getAttribute('data-latitude');
			var storeLongitude = store.getAttribute('data-longitude');
			var distance = getDistanceFromLatLonInKm(latitude, longitude, storeLatitude, storeLongitude);
			if (distance) {
				if (store.querySelector('.store-distance-info')) {
					store.querySelector('.store-distance-info').innerHTML = `${distance} mi`;
				}
			}
		}
	}

	function sortStoresByRelevancy() {
		const selector = element => element.querySelectorAll('.sr-list .store-active-filters .active-filter.active').length;
		const elements = Array.from(document.querySelectorAll('.sr-list'));
		const parentElement = document.querySelector("#store");
		const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });
		elements
			.sort((elementA, elementB) => {
				const [firstElement, secondElement] = [elementA, elementB];
				const lengthOfFirstElement = selector(firstElement);
				const lengthOfSecondElement = selector(secondElement);
				return collator.compare(lengthOfSecondElement, lengthOfFirstElement);
			})
			.forEach(element => {
				parentElement.appendChild(element);
			});
	}

	function sortStoresByDistance() {
		const selector = element => element.querySelector('.sr-list .store-distance-info').innerHTML;
		const elements = Array.from(document.querySelectorAll('.sr-list'));
		const parentElement = document.querySelector("#store");
		const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });
		elements
			.sort((elementA, elementB) => {
				const [firstElement, secondElement] = [elementA, elementB];
				const textOfFirstElement = selector(firstElement);
				const textOfSecondElement = selector(secondElement);
				return collator.compare(textOfFirstElement, textOfSecondElement);
			})
			.forEach(element => {
				parentElement.appendChild(element);
			});
	}

	function showPosition(position) {
		setDistances(position.coords.latitude, position.coords.longitude);
	}

	function getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
		var R = 6371; // Radius of the earth in km
		var dLat = deg2rad(lat2 - lat1);  // deg2rad below
		var dLon = deg2rad(lon2 - lon1);
		var a =
			Math.sin(dLat / 2) * Math.sin(dLat / 2) +
			Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
			Math.sin(dLon / 2) * Math.sin(dLon / 2)
			;
		var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
		var d = R * c; // Distance in km

		var kms = 5;
		var miles = d / 1.609;

		var num = parseFloat(miles);
		return num.toFixed(2);
	}

	function deg2rad(deg) {
		return deg * (Math.PI / 180);
	}

	function addDataAttributes() {
		allStoreDiv.forEach(store => {
			let storeAmenities = [];
			let storeDepartments = [];
			store.querySelectorAll('.depart-cl > li').forEach(department => {
				storeDepartments.push(department.getAttribute('data-id'));
			});
			store.setAttribute('data-amenities', storeAmenities);
			store.querySelectorAll('.amenities-cl > li').forEach(amenity => {
				storeAmenities.push(amenity.getAttribute('data-id'));
			});
			store.setAttribute('data-departments', storeDepartments);
			store.setAttribute('data-amenities', storeAmenities);
		});
	}

	function setStickyElementsOffset() {
		const siteHeaderEl = document.querySelector('.site-header');
		const alertBannerEl = document.querySelector('section.alert-banner');
		const storeLocationBannerEl = document.querySelector('.store-location-banner');

		if (siteHeaderEl && alertBannerEl && storeLocationBannerEl) {
			const height1 = siteHeaderEl.offsetHeight;
			const height2 = alertBannerEl.offsetHeight;

			const combinedHeight = height1 + height2;

			storeLocationBannerEl.style.top = `${ combinedHeight }px`;
		} else if (siteHeaderEl && storeLocationBannerEl) {
			storeLocationBannerEl.style.top = `${ siteHeaderEl.offsetHeight }px`;
		} else {
			console.error('Could not set offset. Elements required do not exist.');
		}
	}

	function onAlertClassChange(mutationsList, observer) {
		for (let mutation of mutationsList) {
			if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
				console.log('Class attribute changed!');
				// Access the target element
				const targetElement = mutation.target;
				console.log('New class list:', targetElement.classList);
				// Additional logic can be added here based on your requirements
				const siteHeaderEl = document.querySelector('.site-header');
				const storeLocationBannerEl = document.querySelector('.store-location-banner');
				storeLocationBannerEl.style.top = `${ siteHeaderEl.offsetHeight }px`;
			}
		}
	}

	function observeAlertChanges() {
		const alertBannerEl = document.querySelector('section.alert-banner');

		if (!alertBannerEl) {
			console.error('Element not found');
			return;
		}

		const observer = new MutationObserver(onAlertClassChange);

		const config = {
			attributes: true,
			attributeFilter: ['class'],
		};

		// Start observing the target element for configured mutations
		observer.observe(alertBannerEl, config);
	}

	function init() {
		attachEvents();
		addDataAttributes();
		setDistances(latitude, longitude);
		sortStoresByDistance();
		setStickyElementsOffset();
		observeAlertChanges();
		window.addEventListener('resize', () => {
			setStickyElementsOffset();
		});
	}
	init();
})();